// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchInput_searchInput__V3sQo"};